import { GqlPlannerVisitStatus } from "~/__generated__";
import { IsRejectedAlert } from "~/shared/components/IsRejectedAlert";

import { ProjectReviewVisitV2RejectionAlertFragment } from "./fragments.generated";

type Props = {
    visit: ProjectReviewVisitV2RejectionAlertFragment;
};

export function ProjectReviewVisitV2RejectionAlert({ visit }: Props) {
    if (visit.status !== GqlPlannerVisitStatus.Unplanned || !visit.rejectedAt || !visit.rejectedByUser) {
        return null;
    }

    return (
        <IsRejectedAlert
            actor={visit.rejectedByUser}
            color="error"
            date={visit.rejectedAt}
            reason={visit.rejectionReason ?? undefined}
            variant="rejected"
        />
    );
}
